import '../assets/NcEmptyContent-ClLPsXo5.css';
import { n as s } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const i = {
  name: "NcEmptyContent",
  props: {
    /**
     * A header message about an empty content shown
     * @example 'No comments'
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Desription of the empty content
     * @example 'No comments yet, start the conversation!'
     */
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasName() {
      return this.name !== "";
    },
    /**
     * Check if a description is given as either property or slot
     */
    hasDescription() {
      var e;
      return this.description !== "" || ((e = this.$slots.description) == null ? void 0 : e[0]);
    }
  }
};
var a = function() {
  var t = this, n = t._self._c;
  return n("div", { staticClass: "empty-content", attrs: { role: "note" } }, [t.$slots.icon ? n("div", { staticClass: "empty-content__icon", attrs: { "aria-hidden": "true" } }, [t._t("icon")], 2) : t._e(), t._t("name", function() {
    return [t.hasName ? n("span", { staticClass: "empty-content__name" }, [t._v(" " + t._s(t.name) + " ")]) : t._e()];
  }), t.hasDescription ? n("p", { staticClass: "empty-content__description" }, [t._t("description", function() {
    return [t._v(" " + t._s(t.description) + " ")];
  })], 2) : t._e(), t.$slots.action ? n("div", { staticClass: "empty-content__action" }, [t._t("action")], 2) : t._e()], 2);
}, o = [], r = /* @__PURE__ */ s(
  i,
  a,
  o,
  !1,
  null,
  "458108e7",
  null,
  null
);
const _ = r.exports;
export {
  _ as default
};
